import React, { useEffect, useRef, useState } from "react";
import Cookies from 'js-cookie';
import { apiCall } from "../../utils/Api";
import { showError } from "../../ui/Message";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import Float from "../../ui/Float";
import Button from "../../ui/Button";
import { kbdEvent } from "../../utils/Utils";

export default function Login(props) {

    const { loading = false, setLoading = () => { }, state = "login", setState = () => { }, session = {}, setSession = () => { }, route = "" } = props;

    const refs = useRef([]);
    const [index, setIndex] = useState("email");

    const [tabs, setTabs] = useState([
        { key: "email", value: "" },
        { key: "password", value: "" },
    ])

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });

    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };


    const getSession = () => {
        setLoading(true);
        let _obj = {};
        if (Cookies.get("bmo_session_id")) {
            _obj.session_id = Cookies.get("bmo_session_id");
        }
        apiCall("session/get", _obj, (_s, _r) => {
            if (_s) {
                Cookies.set("bmo_session_id", _r.session_id);
                setSession(_r);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(getSession, []);


    const login = () => {
        
        let obj = {
            session_id: session?.session_id,
            password: getVal("password"),
        }

        const _email = getVal("email");

        if(_email.includes("@")){
            obj.email_address = _email;
        } else {
            obj.san = _email;
        }


        if(!(obj.email_address || obj.san) || !obj.password){
            showError({error : "Email/SAN and password required"})
            return; 
        }
        
        setLoading(true);
        apiCall("account/login", obj, (_s, _r) => {
            if (_s) {
                setSession(_r);
            } else {
                showError(_r.error)
            }
            setLoading(false);
        })
    }

    const onEnter = () => {
        login();
    }


    useEffect(() => {
        if (refs?.current[index]) {
            refs.current[index].focus();
        }
        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ENTER, action: (e) => { (index === "email") ? next() : onEnter() } },
            { key: KBD.PAGE_DOWN, action: (e) => { onEnter() } }
        ];
        const cleanup = listen(route, actions, (e) => {}, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, tabs, update]);



    return (

        <div>
            <Label style={{ "textAlign": "left" }} width={150}>Email address / SAN</Label>
            <div className="shim" />
            <Input {...editProps("email")} maxLength={40} autoselect width={250} value={getVal("email")} />
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }} width={150}>Password</Label>
            <div className="shim" />
            <Input {...editProps("password")} password maxLength={40} autoselect width={250} value={getVal("password")} />
            <div className="shim" /> <div className="shim" /> <div className="shim" />
            <Float>
                <div></div>
                <Button kbd={KBD.PAGE_DOWN} onClick={() => { kbdEvent(KBD.PAGE_DOWN)}}  type="secondary">Login</Button>
            </Float>
        </div>

    )
}